module.exports = __webpack_public_path__ + "static/img/10025.c94c480a.png";